import React from 'react'
import Resources from '../pages/Resources'


const SystemDesign = () => {
  return (
    <div>
            <Resources />
    </div>
  )
}

export default SystemDesign;